import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from '../components/Header';
import Hero from '../components/Hero';
import MainCategories from '../components/MainCategories';
import CategoryBanner from '../components/CategoryBanner';
import ServiceList from '../components/ServiceList';
import LatestNews from '../components/LatestNews';
const API = "/api";

export default function ServicePage() {
    const [mainCategories, setMainCategories] = useState([]);
    const [allServices, setAllServices] = useState([]);
    const [activeMainCategory, setActiveMainCategory] = useState(null);

    // Грузим всё один раз; фильтрация по категории — на клиенте (мгновенно, без запросов)
    useEffect(() => {
        axios.get(`${API}/main_categories`)
            .then((res) => setMainCategories(res.data))
            .catch((error) => console.error('Failed to load categories:', error));
        axios.get(`${API}/all_services`)
            .then((res) => setAllServices(res.data))
            .catch((error) => console.error('Failed to load services:', error));
    }, []);

    const services = activeMainCategory
        ? allServices.filter((c) => c.id === activeMainCategory)
        : allServices;

    return (
        <div className="flex flex-col items-center w-full min-h-screen">
            <Header />
            <Hero />
            <LatestNews />
            <MainCategories
                categories={mainCategories}
                activeCategory={activeMainCategory}
                onSelectCategory={(id) => setActiveMainCategory(id)}
            />
            <CategoryBanner />
            <ServiceList servicesList={services} />
        </div>
    );
}
